// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__24Oxz","notes":"Notes_notes__3Yq1r"};